import { defineChannel, type ChannelDefinition } from '../channel-definition';

// Still sends for workspaces with `urban_airship` in `enabled_actions`, and keeps
// its settings page, but isn't offered to new workspaces.
export const urbanAirshipChannel = defineChannel({
  id: 'urban_airship',
  icon: 'mobile',
} as const satisfies ChannelDefinition);
